/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AddsavedsearchCreateParams {
    request?: AddSavedSearchApiRequest;
}

export interface AllClothesBrandAttributeValuesRequest {
    request?: GetAllClothesBrandAttributeValuesApiRequest;
}

export interface AllClothesSizeAttributeValuesRequest {
    request?: GetAllClothesSizeAttributeValuesApiRequest;
}

export interface AttributedefinitionsRequest {
    request?: GetAllAttributeDefinitionsApiRequest;
}

export interface BrandPageRequest {
    brand?: string;
    /** @format int32 */
    pageSize?: number;
    languageCodeIso2?: string;
    automaticTranslationPreferred?: boolean;
    shippingCountryCodeIso2?: string;
    allowedBuyerRegions?: string;
}

export interface CategoryPageCreateParams {
    request?: CategoryPageApiRequest;
}

export interface CategorySearchRequest {
    query?: string;
    searchLanguageCodeIso2?: string;
}

export interface CausesPageCausesItemsCreateParams {
    request?: CausesItemsApiRequest;
}

export interface CustomResultPagesCampaignPageCreateParams {
    request?: CampaignPageApiRequest;
}

export interface CustomResultPagesCausePageCreateParams {
    request?: CausePageApiRequest;
}

export interface CustomResultPagesCharityPageCreateParams {
    request?: CharityPageApiRequest;
}

export interface CustomResultPagesShopPageCreateParams {
    request?: ShopPageApiRequest;
}

export interface DisableWardrobeProfileCreateParams {
    request?: DisableWardrobeProfileApiRequest;
}

export interface EnableWardrobeProfileCreateParams {
    request?: EnableWardrobeProfileApiRequest;
}

export interface FavouritesellersAndItems2Request {
    /** @format int32 */
    maxFavouriteSellers?: number;
    /** @format int32 */
    maxItems?: number;
    /** @format int32 */
    maxItemsPerFavouriteSeller?: number;
    /** @format int32 */
    skipItems?: number;
    shippingCountryCode?: string;
    userLanguage?: string;
    automaticTranslationPreferred?: boolean;
}

export interface FavouritesellersCreateParams {
    request?: AddFavouriteSellerApiRequest;
}

export interface FavouritesellersDeleteParams {
    request?: RemoveFavouriteSellersApiRequest;
}

export interface FavouritesellersRequest {
    request?: GetFavouriteSellersApiRequest;
}

export interface ForShopDetailParams {
    /** @format int32 */
    size?: number;
    allowedBuyerRegions?: string[];
    searchResultLanguageCodeIso2?: string;
    /** @format int32 */
    itemId: number;
}

export interface GetBlueshiftEmailPreferencesLinkRequest {
    request?: GetBlueshiftEmailPreferencesLinkApiRequest;
}

export interface HistogramCreateParams {
    request?: SearchCategoryHistogramApiRequest;
}

export interface ImageSearchCreateParams {
    request?: ImageSearchApiRequest;
}

export interface ImageSearchItemCreateParams {
    request?: ImageSearchFromItemIdApiRequest;
}

export interface IndependentSearchCreateParams {
    request?: IndependentSearchApiRequest;
}

export interface ItemsItemsByIdsRequest {
    searchLanguageCodeIso2?: string;
    automaticTranslationPreferred?: boolean;
    itemIds?: number[];
}

export interface MemberSearchFiltersCreateParams {
    request?: UpdateMemberSearchFiltersApiRequest;
}

export interface MemberSearchFiltersRequest {
    request?: GetMembersSearchFiltersApiRequest;
}

export interface MoreFromSellerCreateParams {
    request?: MoreFromSellerApiRequest;
}

export interface MoreFromSellerRequest {
    /** @format int32 */
    sellerMemberId?: number;
    /** @format int32 */
    size?: number;
    searchResultLanguageCodeIso2?: string;
}

export interface MoreItemsForCombinedShippingFromSellerCreateParams {
    request?: MoreItemsFromSellerForCombinedShippingApiRequest;
}

export interface MoreItemsForCombinedShippingRequest {
    shippingCountryCodeIso2?: string;
    searchLanguageCodeIso2?: string;
    automaticTranslationPreferred?: boolean;
    /** @format int32 */
    itemId?: number;
    /** @format int32 */
    pageSize?: number;
}

export interface MoreItemsFromCategoryRequest {
    shippingCountryCodeIso2?: string;
    searchLanguageCodeIso2?: string;
    automaticTranslationPreferred?: boolean;
    /** @format int32 */
    itemId?: number;
    /** @format int32 */
    pageSize?: number;
}

export interface MoreItemsFromSellerRequest {
    shippingCountryCodeIso2?: string;
    searchLanguageCodeIso2?: string;
    automaticTranslationPreferred?: boolean;
    /** @format int32 */
    itemId?: number;
    /** @format int32 */
    pageSize?: number;
}

export interface MoreItemsFromShopRequest {
    shippingCountryCodeIso2?: string;
    searchLanguageCodeIso2?: string;
    automaticTranslationPreferred?: boolean;
    /** @format int32 */
    itemId?: number;
    /** @format int32 */
    pageSize?: number;
}

export interface MorefromcampaignRequest {
    query?: string;
    campaignCodeIds?: number[];
    excludeItemIds?: number[];
    /** @format int32 */
    size?: number;
    searchResultLanguageCodeIso2?: string;
}

export interface OthersAlsoLookedAtDetailParams {
    /** @format int32 */
    size?: number;
    automaticTranslationPreferred?: boolean;
    userLanguage?: string;
    /** @format int32 */
    itemId: number;
}

export interface PersonalizedRecommendationSearchRequest {
    languageCodeIso2?: string;
    automaticTranslationPreferred?: boolean;
    allowedBuyerRegions?: string[];
}

export interface ProfilePageProfileItemsCreateParams {
    request?: ProfileItemsApiRequest;
}

export interface RecommendationsV3Request {
    slot?: string;
    seedItemIds?: number[];
    cookie?: string;
    /** @format int32 */
    maxResults?: number;
    /** @format int32 */
    pageNumber?: number;
    /** @format int32 */
    seedCategoryId?: number;
    searchResultLanguageCodeIso2?: string;
}

export interface RecommendationsV4Request {
    slot?: string;
    shippingCountryCode?: string;
    seedItemIds?: number[];
    /** @format int32 */
    maxResults?: number;
    /** @format int32 */
    pageNumber?: number;
    userLanguage?: string;
    automaticTranslationPreferred?: boolean;
    /** @format int32 */
    seedCategoryId?: number;
}

export interface RemovesavedsearchDeleteParams {
    request?: RemoveSavedSearchApiRequest;
}

export interface RemovesavedsearchesDeleteParams {
    request?: RemoveSavedSearchesApiRequest;
}

export interface SavedsearchemailnotificationCreateParams {
    request?: SavedSearchEmailNotificationApiRequest;
}

export interface SavedsearchesRequest {
    sortBy?: string;
}

export interface SavedsearchesitemsRequest {
    /** @format int32 */
    maxSearches?: number;
    /** @format int32 */
    maxItemsPerSearch?: number;
    /** @format int32 */
    skipSearches?: number;
    sortBy?: string;
    languageCodeIso2?: string;
}

export interface SavedsearchesparametersRequest {
    /** @format int32 */
    memberId?: number;
    /** @format int32 */
    savedSearchId?: number;
}

export interface SearchCreateParams {
    request?: ExecuteCustomResultPageSearchApiRequest;
    id: string;
}

export interface SearchRequest {
    query?: string;
    /** @format int32 */
    page?: number;
    /** @format int32 */
    pageSize?: number;
}

export interface SearchPageCreateParams {
    request?: SearchPageApiRequest;
}

export interface SearchV2CreateParams {
    request?: ExecuteSavedSearchForCurrentUserApiRequest;
}

export interface SellerListRequest {
    /** @format int32 */
    maxSellers?: number;
    /** @format int32 */
    maxItemsPerSeller?: number;
    /** @format int32 */
    skipSellers?: number;
    shippingCountryCode?: string;
}

export interface SellerListSearchRequest {
    query?: string;
    /** @format int32 */
    page?: number;
    /** @format int32 */
    pageSize?: number;
}

export interface SellerSuggestionsRequest {
    /** @format int32 */
    maxSellers?: number;
    /** @format int32 */
    maxItemsPerSeller?: number;
    /** @format int32 */
    skipSellers?: number;
    shippingCountryCode?: string;
}

export interface ServerTimeRequest {
    request?: ServerTimeApiRequest;
}

export interface SimilarItemsDetailParams {
    /** @format int32 */
    size?: number;
    allowedBuyerRegions?: string[];
    searchResultLanguageCodeIso2?: string;
    /** @format int32 */
    itemId: number;
}

export interface SimilarItemsV2DetailParams {
    /** @format int32 */
    size?: number;
    automaticTranslationPreferred?: boolean;
    userLanguage?: string;
    shippingCountryCodeIso2?: string;
    /** @format int32 */
    itemId: number;
}

export interface SimilarSellerSuggestionsRequest {
    /** @format int32 */
    sellerMemberId?: number;
    /** @format int32 */
    maxSellers?: number;
    keepSellersWithNoItems?: boolean;
}

export interface StartPageBrandSuggestionsRequest {
    request?: BrandSuggestionsApiRequest;
}

export interface StartPageCreateParams {
    request?: StartPageApiRequest;
}

export interface StartPageIdeasRequest {
    languageCodeIso2?: string;
}

export interface StartPageInstagramFeedRequest {
    request?: InstagramFeedApiRequest;
}

export interface StartPageLastChanceRequest {
    shippingCountryCodeIso2?: string;
    languageCodeIso2?: string;
    automaticTranslationPreferred?: boolean;
    /** @format int32 */
    limit?: number;
}

export interface StartPageNewsForYouRequest {
    languageCodeIso2?: string;
    automaticTranslationPreferred?: boolean;
}

export interface StartPagePersonalisedSearchesRequest {
    request?: PersonalisedSearchesApiRequest;
}

export interface StartPageResellSuggestionsRequest {
    languageCodeIso2?: string;
    automaticTranslationPreferred?: boolean;
    /** @format int32 */
    take?: number;
}

export interface StartPageSellersOfInterestRequest {
    shippingCountryCode?: string;
    /** @format int32 */
    maxSellers?: number;
}

export interface StartPageTrendingBrandsRequest {
    request?: TrendingBrandsApiRequest;
}

export interface StartPageTrendingSearchesRequest {
    languageCodeIso2?: string;
}

export interface SuggestionsByParentsCreateParams {
    request?: CategoriesSuggestionsApiRequest;
}

export interface SuggestionsTopLevelCreateParams {
    request?: RootCategorySuggestionsApiRequest;
}

export interface TopListsRequest {
    languageCodeIso2?: string;
    automaticTranslationPreferred?: boolean;
}

export interface ResponseError {
    errorCode?: string | null;
    fieldName?: string | null;
    message?: string | null;
}

export interface ResponseError3 {
    request?: ExecuteSavedSearchApiRequest;
}

export interface ResponseError7 {
    request?: Search2ApiRequest;
}

export interface ResponseError5 {
    languageCodeIso2?: string;
    automaticTranslationPreferred?: boolean;
}

export interface ResponseError7 {
    request?: Search2ApiRequest;
}

export interface ResponseStatus {
    errorCode?: string | null;
    errors?: ResponseError[] | null;
    message?: string | null;
    stackTrace?: string | null;
}

export interface CategoryNodeApiDto {
    alternativeName?: string | null;
    /** @format int32 */
    count?: number | null;
    /** @format int32 */
    id: number;
    isLeaf: boolean;
    /** @format int32 */
    level: number;
    name?: string | null;
}

export interface ItemScoreDto {
    /** @format int32 */
    categoryLeafId: number;
    itemId?: string | null;
    /** @format double */
    rank: number;
    searchResultOrigin?: SearchResultOrigin | null;
}

export interface ResourceLink {
    href?: string | null;
    /** @format int32 */
    index: number;
    paging?: string | null;
    rel?: string | null;
    text?: string | null;
}

export interface SearchResultHitsPerCategoryApiDto {
    categories?: CategoryNodeApiDto[] | null;
    current?: CategoryNodeApiDto | null;
    parents?: CategoryNodeApiDto[] | null;
}

export enum SearchResultOrigin {
    Keyword = 'Keyword',
    Vector = 'Vector',
    KeywordAndVector = 'KeywordAndVector',
}

export interface ShippingOption {
    /** @format int32 */
    cost: number;
    type?: string | null;
}

export interface AggregationRow {
    /** @format int64 */
    count: number;
    displayName?: string | null;
    name?: string | null;
    searchFilter?: any;
    /** @format int32 */
    sortOrder: number;
    swedishDisplayName?: string | null;
}

export interface NewsForYouApiResponse_App {
    items?: SearchResultItem2ApiDto[] | null;
    responseStatus?: ResponseStatus | null;
    /** @format int64 */
    totalItemCount: number;
}

export interface AttributeDefinition {
    backingField?: string | null;
    /** @format int64 */
    id: number;
    possibleValues?: string[] | null;
    shouldTranslateValues: boolean;
}

export interface AttributeFacetResults {
    termFacets?: TermFacetResults[] | null;
}

export interface BlueshiftRecommendations4ApiResponse {
    items?: ItemCardDto[] | null;
    /** @format int32 */
    itemsMatched: number;
    responseStatus?: ResponseStatus | null;
}

export interface BlueshiftRecommendationsApiResponse {
    responseStatus?: ResponseStatus | null;
    result?: Search2ApiResult | null;
}

export interface CategoriesSuggestionsApiRequest {
    /** @format int32 */
    categoryLevel: number;
    parentCategoryIds?: number[] | null;
    shortDescription?: string | null;
}

export interface CategoriesSuggestionsApiResponse {
    categoriesAndSuggestions?: Record<string, CategoriesAndSuggestionsDto>;
    responseStatus?: ResponseStatus | null;
}

export interface CategoryHits {
    categories?: ValuationSearchCategory[] | null;
    /** @format int32 */
    count: number;
}

export interface CategorySearchApiResponse {
    categories?: SearchCategoryGroup[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface ExecuteCustomResultPageSearchApiRequest {
    id?: string | null;
    searchOverrides?: Search2ApiRequest | null;
}

export interface ExecuteCustomResultPageSearchApiResponse {
    response?: Search2ApiResponse | null;
    responseStatus?: ResponseStatus | null;
    searchRequest?: Search2ApiRequest | null;
}

export interface AttributeValues {
    numberAttributeValues?: NumberAttributeValue[] | null;
    termAttributeValues?: TermAttributeValue[] | null;
}

export interface AttributeFacets {
    rangeFacets?: RangeFacet[] | null;
    termFacets?: TermFacet_CustomName1[] | null;
}

export interface Range {
    customKey?: string | null;
    /** @format double */
    from?: number | null;
    /** @format double */
    to?: number | null;
}

export interface RangeFacet {
    backingField?: string | null;
    /** @format double */
    filterFrom?: number | null;
    /** @format double */
    filterTo?: number | null;
    id?: string | null;
    /** @format int32 */
    limit: number;
    ranges?: Range[] | null;
}

export interface TermFacet_CustomName1 {
    backingField?: string | null;
    filteredNumbers?: number[] | null;
    filteredTerms?: string[] | null;
    /** @format int32 */
    limit: number;
}

export interface CategoriesAndSuggestionsDto {
    categories?: CategoryDto[] | null;
    suggestions?: SuggestedCategoryDto[] | null;
}

export interface CategoryDto {
    /** @format int32 */
    categoryId: number;
    isLeaf: boolean;
    name?: string | null;
}

export interface ElapsedTime {
    /** @format int64 */
    elapsedMilliseconds: number;
    layerName?: string | null;
}

export interface FavouriteSellerApiDto {
    /** @format int32 */
    activeItems: number;
    /** @format date-time */
    createDate: string;
    hasShopAccount: boolean;
    /** @format int32 */
    id: number;
    /** @format int32 */
    memberId: number;
    sellerAlias?: string | null;
    /** @format int32 */
    sellerId: number;
    /** @format int32 */
    sellerTotalRating: number;
}

export interface FavouriteSellerCardDto {
    hasShop: boolean;
    heroImageUrl?: string | null;
    isSuggestion: boolean;
    items?: FavouriteSellerCardItemDto[] | null;
    /** @format int32 */
    matchedItems: number;
    sellerAlias?: string | null;
    /** @format int32 */
    sellerId: number;
    sellerProfileUrl?: string | null;
}

export interface FavouriteSellerCardItemDto {
    /** @format int32 */
    categoryId: number;
    imageUrl?: string | null;
    imageUrlTemplate?: string | null;
    /** @format int32 */
    itemId: number;
    itemUrl?: string | null;
    shortDescription?: string | null;
}

export interface SimilarSellerCardDto {
    existsInFavouriteSellers: boolean;
    heroImage?: string | null;
    /** @format int32 */
    matchedItems: number;
    sellerAlias?: string | null;
    /** @format int32 */
    sellerId: number;
    sellerProfileUrl?: string | null;
}

export interface Hint {
    name?: string | null;
    value?: string | null;
}

export interface ItemCardDto {
    attributes?: ItemCardDtoItemCardAttribute[] | null;
    /** @format int32 */
    buyNowPrice: number;
    /** @format int32 */
    categoryId: number;
    /** @format int32 */
    discountRate: number;
    displayHighlighted: boolean;
    /** @format date-time */
    endDate: string;
    hasFreeShipping: boolean;
    /** @format int32 */
    imageHeight?: number | null;
    imageSecondaryUrl?: string | null;
    imageSecondaryUrlTemplate?: string | null;
    imageUrl?: string | null;
    imageUrlTemplate?: string | null;
    /** @format int32 */
    imageWidth?: number | null;
    isActive: boolean;
    isAuthenticated: boolean;
    /** @format int32 */
    itemId: number;
    itemType?: string | null;
    itemUrl?: string | null;
    onDisplay: boolean;
    /** @format int32 */
    price: number;
    /** @format int32 */
    priceBeforeDiscount: number;
    reservedPriceReached: boolean;
    sellerAlias?: string | null;
    /** @format double */
    sellerDsrAverage?: number | null;
    /** @format int32 */
    sellerMemberId: number;
    shippingOptions?: ItemCardDtoShippingOption[] | null;
    shortDescription?: string | null;
    /** @format date-time */
    startDate: string;
    /** @format int32 */
    totalBids: number;
}

export interface ItemCardDtoItemCardAttribute {
    name?: string | null;
    values?: string[] | null;
}

export interface ItemCardDtoShippingOption {
    /** @format int32 */
    cost: number;
    type?: string | null;
}

export interface NumberAttributeValue {
    /** @format int32 */
    id: number;
    name?: string | null;
    values?: number[] | null;
}

export enum OfferItemAvailabilityFilter {
    All = 'All',
    AvailableForOffers = 'AvailableForOffers',
    AvailableForOffersOrUnknown = 'AvailableForOffersOrUnknown',
}

export enum QueryScope {
    Narrow = 'Narrow',
    Normal = 'Normal',
    Wide = 'Wide',
}

export enum SearchItemConditionApiDto {
    All = 'All',
    New = 'New',
    Used = 'Used',
}

export enum SearchItemTypeApiDto {
    All = 'All',
    Auction = 'Auction',
    FixedPrice = 'FixedPrice',
}

export interface SearchResultCategoryHistogramApiDto {
    categories?: CategoryNodeApiDto[] | null;
}

export interface SearchResultItem2ApiDto {
    attributeValues?: AttributeValues | null;
    /** @format int32 */
    buyNowPrice: number;
    /** @format int32 */
    categoryId: number;
    /** @format int32 */
    discountRate: number;
    displayHighlighted: boolean;
    displayPromoted: boolean;
    /** @format date-time */
    displaySupersizedUntil?: string | null;
    /** @format date-time */
    endDate: string;
    hasFreeShipping: boolean;
    hasImage: boolean;
    hasNonSpecifiedShipping: boolean;
    hasShopAccount: boolean;
    imageGallerySizeUrl?: string | null;
    /** @format int32 */
    imageHeight?: number | null;
    imageMiniThumbSizeUrl?: string | null;
    imageNormalSizeUrl?: string | null;
    imageSecondaryGallerySizeUrl?: string | null;
    imageThumbSizeUrl?: string | null;
    imageUrlFormats?: string[] | null;
    imageUrlTemplate?: string | null;
    /** @format int32 */
    imageWidth?: number | null;
    isActive: boolean;
    isAuthenticated: boolean;
    isAvailableForOffers?: boolean | null;
    isPickupOnly: boolean;
    /** @format int32 */
    itemId: number;
    /** @format int32 */
    itemStatusId: number;
    itemType?: string | null;
    itemUrl?: string | null;
    links?: ResourceLink[] | null;
    longDescription?: string | null;
    /** @format int32 */
    maxBid: number;
    onDisplay: boolean;
    /** @format int32 */
    openingBid?: number | null;
    paymentOptions?: string[] | null;
    /** @format int32 */
    price: number;
    /** @format int32 */
    priceBeforeDiscount: number;
    /** @format int32 */
    quantityRemaining: number;
    reservedPriceReached: boolean;
    /** @format int32 */
    rootItemId: number;
    sellerAlias?: string | null;
    /** @format double */
    sellerDsrAverage?: number | null;
    /** @format double */
    sellerLocationLat?: number | null;
    /** @format double */
    sellerLocationLong?: number | null;
    /** @format int32 */
    sellerMemberId: number;
    shippingOptions?: ShippingOption[] | null;
    /** @format int32 */
    shippingPrice: number;
    shippingType?: string | null;
    shortDescription?: string | null;
    /** @format double */
    soldPrice?: number | null;
    /** @format date-time */
    startDate: string;
    /** @format int32 */
    totalBids: number;
}

export enum SearchSellerApiDto {
    All = 'All',
    Private = 'Private',
    Company = 'Company',
}

export enum SearchSortOrderApiDto {
    Relevance = 'Relevance',
    TimeLeft = 'TimeLeft',
    AddedOn = 'AddedOn',
    Price = 'Price',
    Bids = 'Bids',
    PriceWithShipping = 'PriceWithShipping',
    MaxSellerDsr = 'MaxSellerDsr',
    HighestWishListCount = 'HighestWishListCount',
    LowestWishListCount = 'LowestWishListCount',
}

export interface SellerOverviewDto {
    alias?: string | null;
    heroImageUrl?: string | null;
    /** @format int32 */
    memberId: number;
    /** @format int32 */
    numberOfActiveItems: number;
}

export interface SellerOverviewWithFavouriteSellerStatusDto {
    alias?: string | null;
    existsInFavouriteSellers: boolean;
    heroImageUrl?: string | null;
    /** @format int32 */
    memberId: number;
    /** @format int32 */
    numberOfActiveItems: number;
}

export interface SuggestedCategoryDto {
    /** @format int32 */
    categoryId: number;
    isLeaf: boolean;
    /** @format int64 */
    matchedItemCount: number;
    name?: string | null;
}

export interface TermAttributeValue {
    autoSelect: boolean;
    /** @format int32 */
    id: number;
    name?: string | null;
    values?: string[] | null;
}

export interface TraderaShopItemDto {
    /** @format int32 */
    fixedPrice: number;
    /** @format int32 */
    itemId: number;
    title?: string | null;
}

export interface TraderaShopProductDto {
    itemSelectionHeader?: string | null;
    items?: TraderaShopItemDto[] | null;
    productName?: string | null;
    shippingInfo?: string | null;
    title?: string | null;
    urlSlug?: string | null;
}

export interface FacetPresentation {
    isMultiSelect: boolean;
    shouldTranslateValues: boolean;
    type?: string | null;
}

export interface AddFavouriteSellerApiRequest {
    /** @format int32 */
    sellerId: number;
}

export interface AddFavouriteSellerApiResponse {
    /** @format int32 */
    createdId: number;
    responseStatus?: ResponseStatus | null;
}

export interface GetFavouriteSellersAndItems2ApiResponse {
    favouriteSellers?: FavouriteSellerCardDto[] | null;
    items?: ItemCardDto[] | null;
    responseStatus?: ResponseStatus | null;
    /** @format int32 */
    totalItems: number;
}

export type GetFavouriteSellersApiRequest = object;

export interface GetFavouriteSellersApiResponse {
    favouriteSellerApiDtos?: FavouriteSellerApiDto[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface RemoveFavouriteSellersApiRequest {
    ids?: number[] | null;
}

export interface RemoveFavouriteSellersApiResponse {
    responseStatus?: ResponseStatus | null;
}

export type GetAllAttributeDefinitionsApiRequest = object;

export interface GetAllAttributeDefinitionsApiResponse {
    attributeDefinitions?: AttributeDefinition[] | null;
    responseStatus?: ResponseStatus | null;
}

export type GetAllClothesBrandAttributeValuesApiRequest = object;

export interface GetAllClothesBrandAttributeValuesApiResponse {
    clothesBrandAttributeValues?: string[] | null;
    responseStatus?: ResponseStatus | null;
}

export type GetAllClothesSizeAttributeValuesApiRequest = object;

export interface GetAllClothesSizeAttributeValuesApiResponse {
    clothesSizeAttributeValues?: string[] | null;
    /** @deprecated */
    clothesSizeChildrenAttributeValues?: string[] | null;
    responseStatus?: ResponseStatus | null;
    shoeSizeAttributeValues?: string[] | null;
}

export type GetBlueshiftEmailPreferencesLinkApiRequest = object;

export interface GetBlueshiftEmailPreferencesLinkApiResponse {
    emailPreferencesLink?: string | null;
    ok: boolean;
    responseStatus?: ResponseStatus | null;
}

export type GetMembersSearchFiltersApiRequest = object;

export interface GetMembersSearchFiltersApiResponse {
    responseStatus?: ResponseStatus | null;
    searchFilters?: SearchFilter[] | null;
}

export interface GetSellerByAliasSearchApiResponse {
    responseStatus?: ResponseStatus | null;
    sellerOverviews?: SellerOverviewDto[] | null;
    /** @format int32 */
    totalSellers: number;
}

export interface GetSellerListApiResponse {
    favouriteSellerCardDtos?: FavouriteSellerCardDto[] | null;
    responseStatus?: ResponseStatus | null;
    /** @format int32 */
    totalSellers: number;
}

export interface GetSellerSuggestionsApiResponse {
    favouriteSellerCardDtos?: FavouriteSellerCardDto[] | null;
    responseStatus?: ResponseStatus | null;
    /** @format int32 */
    totalSellers: number;
}

export interface GetSimilarSellerSuggestionsApiResponse {
    responseStatus?: ResponseStatus | null;
    sellerCardDtos?: SimilarSellerCardDto[] | null;
}

export interface ImageSearchApiRequest {
    searchResultLanguageCodeIso2?: string | null;
    gcsUri?: string | null;
}

export interface ImageSearchApiResponse {
    responseStatus?: ResponseStatus | null;
    result?: Search2ApiResult | null;
}

export interface ImageSearchFromItemIdApiRequest {
    searchResultLanguageCodeIso2?: string | null;
    allowedBuyerRegions?: string[] | null;
    /** @format int32 */
    itemId: number;
}

export interface MoreFromCampaignApiResponse {
    items?: SearchResultItem2ApiDto[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface MoreFromSellerApiRequest {
    searchResultLanguageCodeIso2?: string | null;
    /** @format int32 */
    sellerMemberId: number;
    /** @format int32 */
    size: number;
}

export interface MoreFromSellerApiResponse {
    responseStatus?: ResponseStatus | null;
    result?: Search2ApiResult | null;
}

export interface OthersAlsoLookedAtApiResponse {
    items?: ItemCardDto[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface PersonalizedRecommendationSearchApiResponse {
    items?: ItemCardViewModel[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface RootCategorySuggestionsApiRequest {
    shortDescription?: string | null;
}

export interface RootCategorySuggestionsApiResponse {
    categories?: CategoryDto[] | null;
    responseStatus?: ResponseStatus | null;
    suggestions?: SuggestedCategoryDto[] | null;
}

export interface AddSavedSearchApiRequest {
    savedSearchDto?: SavedSearchApiDto | null;
}

export interface AddSavedSearchApiResponse {
    responseStatus?: ResponseStatus | null;
    /** @format int32 */
    savedSearchCreatedId: number;
    /** @format int32 */
    userId: number;
}

export interface ExecuteSavedSearchApiRequest {
    /** @format int32 */
    id: number;
    savedSearchOverrides?: Search2ApiRequest | null;
    /** @format int32 */
    userId: number;
}

export interface ExecuteSavedSearchApiResponse {
    response?: Search2ApiResponse | null;
    responseStatus?: ResponseStatus | null;
    searchRequest?: SavedSearchApiDto | null;
}

export interface ExecuteSavedSearchForCurrentUserApiRequest {
    /** @format int32 */
    id: number;
    savedSearchOverrides?: Search2ApiRequest | null;
}

export interface GetSavedSearchParametersApiResponse {
    parameters?: SearchRequestParameters | null;
    responseStatus?: ResponseStatus | null;
}

export interface GetSavedSearchesApiResponse {
    responseStatus?: ResponseStatus | null;
    savedSearches?: SavedSearchListItemApiDto[] | null;
    /** @format int32 */
    userId: number;
}

export interface GetSavedSearchesWithItemsApiResponse {
    responseStatus?: ResponseStatus | null;
    savedSearches?: SavedSearchListItem[] | null;
    /** @format int32 */
    totalSearches: number;
}

export interface RemoveSavedSearchApiRequest {
    /** @format int32 */
    id: number;
}

export interface RemoveSavedSearchApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface RemoveSavedSearchesApiRequest {
    ids?: number[] | null;
}

export interface RemoveSavedSearchesApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface SavedSearchEmailNotificationApiRequest {
    savedSearchDto?: SavedSearchEmailNotificationApiDto | null;
}

export interface SavedSearchEmailNotificationApiResponse {
    responseStatus?: ResponseStatus | null;
    /** @format int32 */
    savedSearchId: number;
    sendEmail: boolean;
    sendPush: boolean;
}

export interface SavedSearchListItem {
    attributeNames?: Record<string, string[] | null>;
    categoryName?: string | null;
    hasEnabledEmailNotifications: boolean;
    /** @format int32 */
    id: number;
    items?: SavedSearchItemDto[] | null;
    name?: string | null;
    parameters?: SearchRequestParameters | null;
}

export interface Search2ApiRequest {
    parameters?: SearchRequestParameters | null;
}

export interface Search2ApiResponse {
    responseStatus?: ResponseStatus | null;
    result?: Search2ApiResult | null;
}

export interface Search2ApiResult {
    attributeFacets?: AttributeFacetResults | null;
    brands?: AggregationRow[] | null;
    categoryHits?: SearchResultHitsPerCategoryApiDto | null;
    departments?: AggregationRow[] | null;
    elapsedMilliseconds?: ElapsedTime[] | null;
    filteredSearchWords?: string[] | null;
    genders?: AggregationRow[] | null;
    isCsaSearchQuery: boolean;
    isSavedSearchNotificationsEnabled: boolean;
    itemCondition?: AggregationRow[] | null;
    itemScores?: ItemScoreDto[] | null;
    itemType?: AggregationRow[] | null;
    items?: SearchResultItem2ApiDto[] | null;
    /** @format int32 */
    itemsMatched: number;
    links?: ResourceLink[] | null;
    /** @format double */
    maxFixedPrice?: number | null;
    /** @format double */
    maxPrice?: number | null;
    /** @format int32 */
    pageIndex: number;
    /** @format int32 */
    pageSize: number;
    paging?: string | null;
    priceRange?: AggregationRow[] | null;
    relatedItems?: SearchResultItem2ApiDto[] | null;
    searchHintsUsed?: Hint[] | null;
    searchLanguages?: string[] | null;
    sellerType?: AggregationRow[] | null;
    shoeSize?: AggregationRow[] | null;
    shoeTypes?: AggregationRow[] | null;
    spellingCorrectedSearchString?: string | null;
    subDepartments?: AggregationRow[] | null;
}

export interface SearchCategoryGroup {
    leafCategories?: SearchCategoryLevel[] | null;
    parentCategories?: SearchCategoryLevel[] | null;
}

export interface SearchCategoryHistogramApiRequest {
    alias?: string | null;
    allowedBuyerRegions?: string[] | null;
    /** @format int32 */
    bidCountMax?: number | null;
    /** @format int32 */
    bidCountMin?: number | null;
    /** @format int32 */
    campaignCodeId?: number | null;
    /** @format int32 */
    categoryId?: number | null;
    /** @format int32 */
    county?: number | null;
    device?: string | null;
    /** @format date-time */
    endDateFrom?: string | null;
    /** @format date-time */
    endDateTo?: string | null;
    expiredItems?: boolean | null;
    /** @format double */
    fromPrice?: number | null;
    /** @format int32 */
    fromWishListCount?: number | null;
    imagelinkHints?: Hint[] | null;
    itemCondition: SearchItemConditionApiDto;
    itemType: SearchItemTypeApiDto;
    /** @format int32 */
    itemsPerPage: number;
    /** @format int32 */
    memberId?: number | null;
    /** @format int32 */
    pageIndex: number;
    paging?: string | null;
    query?: string | null;
    queryScope: QueryScope;
    searchHints?: Hint[] | null;
    searchInDescription?: boolean | null;
    /** @format float */
    sellerDsrFrom?: number | null;
    /** @format float */
    sellerDsrTo?: number | null;
    sellerType: SearchSellerApiDto;
    sortBy: SearchSortOrderApiDto;
    sortDescending: boolean;
    /** @format date-time */
    startDateFrom?: string | null;
    /** @format date-time */
    startDateTo?: string | null;
    /** @format double */
    toPrice?: number | null;
    /** @format int32 */
    toWishListCount?: number | null;
    /** @format int32 */
    zipCode?: number | null;
}

export interface SearchCategoryHistogramApiResponse {
    categories?: SearchResultCategoryHistogramApiDto | null;
    elapsedMilliseconds?: ElapsedTime[] | null;
    /** @format int32 */
    itemsMatched: number;
    responseStatus?: ResponseStatus | null;
}

export interface SearchCategoryLevel {
    /** @format int32 */
    categoryId: number;
    isLeaf: boolean;
    /** @format int32 */
    level: number;
    name?: string | null;
}

export interface SearchFilter {
    filterName?: string | null;
    filterValue?: string | null;
}

export interface SearchRequestParameters {
    /** @format int32 */
    addedSince?: number | null;
    alias?: string | null;
    allowedBuyerRegions?: string[] | null;
    applyWardrobeProfileBrands?: boolean | null;
    applyWardrobeProfileChildrenClothesSizes?: boolean | null;
    applyWardrobeProfileClothesSizes?: boolean | null;
    applyWardrobeProfileShoeSizes?: boolean | null;
    /** @deprecated */
    applyWardrobeProfileSizes?: boolean | null;
    attributes?: AttributeFacets | null;
    automaticTranslationPreferred: boolean;
    /** @format int32 */
    bidCountMax?: number | null;
    /** @format int32 */
    bidCountMin?: number | null;
    brandTags?: string[] | null;
    brands?: string[] | null;
    campaignCodeIds?: number[] | null;
    categories?: number[] | null;
    /** @format int32 */
    categoryId?: number | null;
    charityIds?: number[] | null;
    /** @format int32 */
    county?: number | null;
    departments?: string[] | null;
    device?: string | null;
    /** @format date-time */
    endDateFrom?: string | null;
    /** @format date-span */
    endDateSafetyOffset?: string | null;
    /** @format date-time */
    endDateTo?: string | null;
    /** @format int32 */
    endingIn?: number | null;
    expiredItems?: boolean | null;
    forCharity?: boolean | null;
    forceKeywordSearch: boolean;
    /** @format double */
    fromPrice?: number | null;
    /** @format int32 */
    fromWishListCount?: number | null;
    genders?: string[] | null;
    imagelinkHints?: Hint[] | null;
    itemCondition?: SearchItemConditionApiDto | null;
    itemIds?: number[] | null;
    itemStatus?: string | null;
    itemType?: SearchItemTypeApiDto | null;
    /** @format int32 */
    itemsPerPage: number;
    memberIds?: number[] | null;
    offerItemAvailability?: OfferItemAvailabilityFilter | null;
    onDisplay?: boolean | null;
    paging?: string | null;
    query?: string | null;
    queryScope?: QueryScope | null;
    searchHints?: Hint[] | null;
    searchInDescription?: boolean | null;
    sellerCity?: string | null;
    /** @format float */
    sellerDsrFrom?: number | null;
    /** @format float */
    sellerDsrTo?: number | null;
    /** @format int32 */
    sellerLocationDistance?: number | null;
    /** @format double */
    sellerLocationLat?: number | null;
    /** @format double */
    sellerLocationLong?: number | null;
    sellerType?: SearchSellerApiDto | null;
    shippingTypes?: string[] | null;
    shoeSizes?: string[] | null;
    shoeTypes?: string[] | null;
    sortBy?: SearchSortOrderApiDto | null;
    sortDescending: boolean;
    /** @format date-time */
    startDateFrom?: string | null;
    /** @format date-time */
    startDateTo?: string | null;
    subDepartments?: string[] | null;
    /** @format double */
    toPrice?: number | null;
    /** @format int32 */
    toWishListCount?: number | null;
    userLanguage?: string | null;
    /** @format int32 */
    zipCode?: number | null;
}

export type ServerTimeApiRequest = object;

export interface ServerTimeApiResponse {
    /** @format date-time */
    currentTime: string;
    responseStatus?: ResponseStatus | null;
}

export interface SimilarItemsApiResponse {
    items?: SearchResultItem2ApiDto[] | null;
    responseStatus?: ResponseStatus | null;
    searchId?: string | null;
}

export interface SimilarItemsFromShopApiResponse {
    items?: SearchResultItem2ApiDto[] | null;
    responseStatus?: ResponseStatus | null;
    searchId?: string | null;
}

export interface SimilarItemsV2ApiResponse {
    items?: ItemCardDto[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface TermFacet_CustomName2 {
    backingField?: string | null;
    filteredNumbers?: number[] | null;
    filteredTerms?: TermValue[] | null;
    /** @format int32 */
    limit: number;
}

export interface TermFacetResults {
    displayName?: string | null;
    /** @deprecated */
    facet?: TermFacet_CustomName1 | null;
    hits?: AggregationRow[] | null;
    presentation?: FacetPresentation | null;
    preserveHitsOrder: boolean;
    /** @format int32 */
    sortOrder: number;
    termFacet?: TermFacet_CustomName2 | null;
}

export interface TermValue {
    appliedFromWardrobeProfile: boolean;
    value?: string | null;
}

export interface GetTrendingSellersAndItemsApiResponse {
    items?: ItemCardDto[] | null;
    responseStatus?: ResponseStatus | null;
    sellers?: FavouriteSellerCardDto[] | null;
    /** @format int32 */
    totalItems: number;
}

export interface UpdateMemberSearchFiltersApiRequest {
    searchFilters?: SearchFilter[] | null;
}

export interface UpdateMemberSearchFiltersApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface ValuationSearchApiResponse {
    /** @format int32 */
    averagePrice?: number | null;
    /** @format int32 */
    averageStartingPrice?: number | null;
    categoryHits?: CategoryHits[] | null;
    /** @format int32 */
    count: number;
    /** @format int32 */
    highestPrice?: number | null;
    items?: SearchResultItem2ApiDto[] | null;
    /** @format int32 */
    lowestPrice?: number | null;
    /** @format double */
    medianPrice?: number | null;
    /** @format double */
    medianStartingPrice?: number | null;
    responseStatus?: ResponseStatus | null;
    /** @format int32 */
    userPriceDangerThreshold?: number | null;
    /** @format int32 */
    userPriceWarningThreshold?: number | null;
}

export interface ValuationSearchCategory {
    /** @format int32 */
    id: number;
    /** @format int32 */
    level: number;
    name?: string | null;
}

export type DisableWardrobeProfileApiRequest = object;

export interface DisableWardrobeProfileApiResponse {
    responseStatus?: ResponseStatus | null;
}

export type EnableWardrobeProfileApiRequest = object;

export interface EnableWardrobeProfileApiResponse {
    responseStatus?: ResponseStatus | null;
}

export type GetWardrobeProfileApiRequest = object;

export interface GetWardrobeProfileApiResponse {
    isEnabled: boolean;
    responseStatus?: ResponseStatus | null;
    searchFilters?: WardrobeProfileSearchFilter[] | null;
}

export interface WardrobeProfileSearchFilter {
    filterName?: string | null;
    filterValue?: string | null;
}

export interface BrandContentViewModel {
    hero?: BrandHeroImageViewModel | null;
    intro?: string | null;
    links?: BrandLinkViewModel[] | null;
    logo?: string | null;
    slug?: string | null;
    title?: string | null;
}

export interface BrandHeroImageViewModel {
    max?: string | null;
    med?: string | null;
    min?: string | null;
}

export interface BrandLinkViewModel {
    brand?: string | null;
    url?: string | null;
}

export interface BrandNameViewModel {
    slug?: string | null;
    title?: string | null;
}

export interface BrandPageApiResponse {
    brand?: BrandContentViewModel | null;
    items?: ItemCardViewModel[] | null;
    responseStatus?: ResponseStatus | null;
    /** @format int64 */
    totalItemCount: number;
    trendingBrands?: BrandNameViewModel[] | null;
}

export interface CategoryFilterCategoryViewModel {
    alternativeName?: string | null;
    children?: CategoryFilterCategoryViewModel[] | null;
    /** @format int32 */
    count?: number | null;
    /** @format int32 */
    id: number;
    isSelected: boolean;
    name?: string | null;
    /** @format int32 */
    sortOrder: number;
    status?: string | null;
    url?: string | null;
}

export interface CategoryFilterViewModel {
    activeCategory?: CategoryFilterCategoryViewModel | null;
    categoryTree?: CategoryFilterCategoryViewModel | null;
    parameter?: string | null;
    type?: string | null;
}

export interface CategoryContentViewModel {
    headerText?: string | null;
    introText?: string | null;
    mainText?: string | null;
}

export interface CategoryLinkViewModel {
    displayText?: string | null;
    href?: string | null;
    /** @format int32 */
    id: number;
    isSelected: boolean;
    isTopLevel: boolean;
    /** @format int32 */
    level: number;
    name?: string | null;
    selected: boolean;
}

export interface CategoryPageApiRequest {
    languageCodeIso2?: string | null;
    shippingCountryCodeIso2?: string | null;
    alias?: string | null;
    allowedBuyerRegions?: string | null;
    applyWardrobeProfileBrands?: boolean | null;
    applyWardrobeProfileChildrenClothesSizes?: boolean | null;
    applyWardrobeProfileClothesSizes?: boolean | null;
    applyWardrobeProfileShoeSizes?: boolean | null;
    /** @deprecated */
    applyWardrobeProfileSizes?: boolean | null;
    attributes?: Record<string, string[] | null>;
    automaticTranslationPreferred: boolean;
    /** @format int32 */
    categoryId?: number | null;
    county?: string | null;
    /** @format int32 */
    fromNumberOfBids?: number | null;
    /** @format int32 */
    fromPrice?: number | null;
    /** @format int32 */
    fromWishListCount?: number | null;
    itemCondition?: string | null;
    itemStatus?: string | null;
    itemType?: string | null;
    offerItemAvailability?: string | null;
    /** @format int32 */
    pageSize?: number | null;
    paging?: string | null;
    sellerType?: string | null;
    shippingTypes?: string[] | null;
    sortBy?: string | null;
    /** @format int32 */
    toNumberOfBids?: number | null;
    /** @format int32 */
    toPrice?: number | null;
    /** @format int32 */
    toWishListCount?: number | null;
    zipCode?: string | null;
}

export interface CategoryPageApiResponse {
    searchLanguageCodesIso2?: string[] | null;
    categoryContent?: CategoryContentViewModel | null;
    categoryPath?: CategoryLinkViewModel[] | null;
    enableSavedSearch: boolean;
    filters?: FiltersViewModel | null;
    /** @format int32 */
    fromCategoryId?: number | null;
    headerText?: string | null;
    introText?: string | null;
    isCsaSearchQuery: boolean;
    isPermanent?: boolean | null;
    isRedirect: boolean;
    isSavedSearchEmailEnabled: boolean;
    items?: ItemCardViewModel[] | null;
    mainText?: string | null;
    pagination?: PaginationViewModel | null;
    redirect?: CategoryRedirectViewModel | null;
    responseStatus?: ResponseStatus | null;
    searchLanguages?: string[] | null;
    /** @format int32 */
    toCategoryId?: number | null;
    /** @format int64 */
    totalItemCount: number;
    /** @format int64 */
    totalItems: number;
}

export interface CategoryRedirectViewModel {
    /** @format int32 */
    fromCategoryId: number;
    isPermanent: boolean;
    toAttributes?: Record<string, string[] | null>;
    /** @format int32 */
    toCategoryId: number;
}

export interface CausesItemsApiRequest {
    languageCodeIso2: string;
    shippingCountryCodeIso2: string;
    allowedBuyerRegions?: string | null;
    applyWardrobeProfileBrands?: boolean | null;
    applyWardrobeProfileChildrenClothesSizes?: boolean | null;
    applyWardrobeProfileClothesSizes?: boolean | null;
    applyWardrobeProfileShoeSizes?: boolean | null;
    /** @deprecated */
    applyWardrobeProfileSizes?: boolean | null;
    attributes?: Record<string, string[] | null>;
    automaticTranslationPreferred: boolean;
    /** @format int32 */
    categoryId?: number | null;
    /** @format int32 */
    fromNumberOfBids?: number | null;
    /** @format int32 */
    fromPrice?: number | null;
    /** @format int32 */
    fromWishListCount?: number | null;
    itemCondition?: string | null;
    itemStatus?: string | null;
    itemType?: string | null;
    offerItemAvailability?: string | null;
    /** @format int32 */
    pageSize?: number | null;
    paging?: string | null;
    query?: string | null;
    queryScope?: string | null;
    searchInLongDescription?: boolean | null;
    shippingTypes?: string[] | null;
    sortBy?: string | null;
    /** @format int32 */
    toNumberOfBids?: number | null;
    /** @format int32 */
    toPrice?: number | null;
    /** @format int32 */
    toWishListCount?: number | null;
}

export interface CausesItemsApiResponse {
    searchLanguageCodesIso2: string[];
    enableSavedSearch: boolean;
    filters: FiltersViewModel;
    isCsaSearchQuery: boolean;
    items: ItemCardViewModel[];
    pagination: PaginationViewModel;
    redirect?: CausesItemsRedirectViewModel | null;
    responseStatus?: ResponseStatus | null;
    /** @format int64 */
    totalItemCount: number;
}

export interface CausesItemsRedirectViewModel {
    /** @format int32 */
    fromCategoryId: number;
    isPermanent: boolean;
    toAttributes: Record<string, string[]>;
    /** @format int32 */
    toCategoryId: number;
}

export interface CampaignPageApiRequest {
    languageCodeIso2?: string | null;
    shippingCountryCodeIso2?: string | null;
    alias?: string | null;
    allowedBuyerRegions?: string | null;
    applyWardrobeProfileBrands?: boolean | null;
    applyWardrobeProfileChildrenClothesSizes?: boolean | null;
    applyWardrobeProfileClothesSizes?: boolean | null;
    applyWardrobeProfileShoeSizes?: boolean | null;
    /** @deprecated */
    applyWardrobeProfileSizes?: boolean | null;
    attributes?: Record<string, string[] | null>;
    automaticTranslationPreferred: boolean;
    campaignId?: string | null;
    /** @format int32 */
    categoryId?: number | null;
    county?: string | null;
    /** @format int32 */
    fromNumberOfBids?: number | null;
    /** @format int32 */
    fromPrice?: number | null;
    /** @format int32 */
    fromWishListCount?: number | null;
    itemCondition?: string | null;
    itemStatus?: string | null;
    itemType?: string | null;
    offerItemAvailability?: string | null;
    /** @format int32 */
    pageSize?: number | null;
    paging?: string | null;
    query?: string | null;
    sellerType?: string | null;
    shippingTypes?: string[] | null;
    sortBy?: string | null;
    /** @format int32 */
    toNumberOfBids?: number | null;
    /** @format int32 */
    toPrice?: number | null;
    /** @format int32 */
    toWishListCount?: number | null;
    zipCode?: string | null;
}

export interface CampaignPageApiResponse {
    searchLanguageCodesIso2?: string[] | null;
    content?: CrpContentViewModel | null;
    enableSavedSearch: boolean;
    filters?: FiltersViewModel | null;
    isCsaSearchQuery: boolean;
    items?: ItemCardViewModel[] | null;
    pagination?: PaginationViewModel | null;
    redirectUrl?: string | null;
    responseStatus?: ResponseStatus | null;
    /** @format int64 */
    totalItemCount: number;
}

export interface CausePageApiRequest {
    languageCodeIso2?: string | null;
    shippingCountryCodeIso2?: string | null;
    alias?: string | null;
    allowedBuyerRegions?: string | null;
    applyWardrobeProfileBrands?: boolean | null;
    applyWardrobeProfileChildrenClothesSizes?: boolean | null;
    applyWardrobeProfileClothesSizes?: boolean | null;
    applyWardrobeProfileShoeSizes?: boolean | null;
    /** @deprecated */
    applyWardrobeProfileSizes?: boolean | null;
    attributes?: Record<string, string[] | null>;
    automaticTranslationPreferred: boolean;
    /** @format int32 */
    categoryId?: number | null;
    causeId?: string | null;
    county?: string | null;
    /** @format int32 */
    fromNumberOfBids?: number | null;
    /** @format int32 */
    fromPrice?: number | null;
    /** @format int32 */
    fromWishListCount?: number | null;
    itemCondition?: string | null;
    itemStatus?: string | null;
    itemType?: string | null;
    offerItemAvailability?: string | null;
    /** @format int32 */
    pageSize?: number | null;
    paging?: string | null;
    query?: string | null;
    sellerType?: string | null;
    shippingTypes?: string[] | null;
    sortBy?: string | null;
    /** @format int32 */
    toNumberOfBids?: number | null;
    /** @format int32 */
    toPrice?: number | null;
    /** @format int32 */
    toWishListCount?: number | null;
    zipCode?: string | null;
}

export interface CausePageApiResponse {
    searchLanguageCodesIso2?: string[] | null;
    content?: CrpContentViewModel | null;
    enableSavedSearch: boolean;
    filters?: FiltersViewModel | null;
    isCsaSearchQuery: boolean;
    items?: ItemCardViewModel[] | null;
    pagination?: PaginationViewModel | null;
    redirectUrl?: string | null;
    responseStatus?: ResponseStatus | null;
    /** @format int64 */
    totalItemCount: number;
}

export interface CharityPageApiRequest {
    languageCodeIso2?: string | null;
    shippingCountryCodeIso2?: string | null;
    alias?: string | null;
    allowedBuyerRegions?: string | null;
    applyWardrobeProfileBrands?: boolean | null;
    applyWardrobeProfileChildrenClothesSizes?: boolean | null;
    applyWardrobeProfileClothesSizes?: boolean | null;
    applyWardrobeProfileShoeSizes?: boolean | null;
    /** @deprecated */
    applyWardrobeProfileSizes?: boolean | null;
    attributes?: Record<string, string[] | null>;
    automaticTranslationPreferred: boolean;
    /** @format int32 */
    categoryId?: number | null;
    charityId?: string | null;
    county?: string | null;
    /** @format int32 */
    fromNumberOfBids?: number | null;
    /** @format int32 */
    fromPrice?: number | null;
    /** @format int32 */
    fromWishListCount?: number | null;
    itemCondition?: string | null;
    itemStatus?: string | null;
    itemType?: string | null;
    offerItemAvailability?: string | null;
    /** @format int32 */
    pageSize?: number | null;
    paging?: string | null;
    query?: string | null;
    sellerType?: string | null;
    shippingTypes?: string[] | null;
    sortBy?: string | null;
    /** @format int32 */
    toNumberOfBids?: number | null;
    /** @format int32 */
    toPrice?: number | null;
    /** @format int32 */
    toWishListCount?: number | null;
    zipCode?: string | null;
}

export interface CharityPageApiResponse {
    searchLanguageCodesIso2?: string[] | null;
    content?: CrpContentViewModel | null;
    enableSavedSearch: boolean;
    filters?: FiltersViewModel | null;
    isCsaSearchQuery: boolean;
    items?: ItemCardViewModel[] | null;
    pagination?: PaginationViewModel | null;
    redirectUrl?: string | null;
    responseStatus?: ResponseStatus | null;
    /** @format int64 */
    totalItemCount: number;
}

export interface CrpBannerLinkViewModel {
    href?: string | null;
    text?: string | null;
    title?: string | null;
}

export interface CrpBannerViewModel {
    cssClass?: string | null;
    desktopImageUrl?: string | null;
    desktopRetinaImageUrl?: string | null;
    links?: CrpBannerLinkViewModel[] | null;
    mobileImageUrl?: string | null;
    mobileRetinaImageUrl?: string | null;
    tabletImageUrl?: string | null;
    tabletRetinaImageUrl?: string | null;
    ticker?: CrpTickerViewModel | null;
}

export interface CrpCharityViewModel {
    description?: string | null;
    name?: string | null;
}

export interface CrpContentViewModel {
    banner?: CrpBannerViewModel | null;
    charity?: CrpCharityViewModel | null;
    crpLabel?: string | null;
    externalEmbeddingOptions?: CrpExternalEmbeddingOptionsViewModel | null;
    headline?: string | null;
    heroImageUrl?: string | null;
    id?: string | null;
    introText?: string | null;
    introTitle?: string | null;
    isVerified: boolean;
    logoImageUrl?: string | null;
    metaDescription?: string | null;
    pageTitle?: string | null;
    searchBar?: CrpSearchBarViewModel | null;
    seoText?: string | null;
    seoTextHeader?: string | null;
    socialMedia?: CrpSocialMediaViewModel | null;
}

export interface CrpExternalEmbeddingOptionsViewModel {
    externalSites?: string | null;
    isEnabled: boolean;
}

export interface CrpInstagramPostViewModel {
    id?: string | null;
    thumbnailUrl?: string | null;
}

export interface CrpSearchBarViewModel {
    placeholder?: string | null;
    query?: string | null;
    showSearchBar: boolean;
}

export interface CrpSocialMediaViewModel {
    instagramAlias?: string | null;
    instagramPosts?: CrpInstagramPostViewModel[] | null;
    youtubeVideoIds?: string[] | null;
}

export interface CrpTickerViewModel {
    campaignCodeIds?: number[] | null;
    /** @format double */
    targetValue?: number | null;
    /** @format double */
    totalEarnings: number;
}

export interface ShopPageApiRequest {
    languageCodeIso2?: string | null;
    shippingCountryCodeIso2?: string | null;
    alias?: string | null;
    allowedBuyerRegions?: string | null;
    applyWardrobeProfileBrands?: boolean | null;
    applyWardrobeProfileChildrenClothesSizes?: boolean | null;
    applyWardrobeProfileClothesSizes?: boolean | null;
    applyWardrobeProfileShoeSizes?: boolean | null;
    /** @deprecated */
    applyWardrobeProfileSizes?: boolean | null;
    attributes?: Record<string, string[] | null>;
    automaticTranslationPreferred: boolean;
    /** @format int32 */
    categoryId?: number | null;
    county?: string | null;
    /** @format int32 */
    fromNumberOfBids?: number | null;
    /** @format int32 */
    fromPrice?: number | null;
    /** @format int32 */
    fromWishListCount?: number | null;
    itemCondition?: string | null;
    itemStatus?: string | null;
    itemType?: string | null;
    offerItemAvailability?: string | null;
    /** @format int32 */
    pageSize?: number | null;
    paging?: string | null;
    query?: string | null;
    sellerType?: string | null;
    shippingTypes?: string[] | null;
    shopId?: string | null;
    sortBy?: string | null;
    /** @format int32 */
    toNumberOfBids?: number | null;
    /** @format int32 */
    toPrice?: number | null;
    /** @format int32 */
    toWishListCount?: number | null;
    zipCode?: string | null;
}

export interface ShopPageApiResponse {
    searchLanguageCodesIso2?: string[] | null;
    content?: CrpContentViewModel | null;
    enableSavedSearch: boolean;
    filters?: FiltersViewModel | null;
    isCsaSearchQuery: boolean;
    items?: ItemCardViewModel[] | null;
    pagination?: PaginationViewModel | null;
    redirectUrl?: string | null;
    responseStatus?: ResponseStatus | null;
    /** @format int64 */
    totalItemCount: number;
}

export interface FilterOptionViewModel {
    appliedFromWardrobeProfile: boolean;
    /** @format int64 */
    count?: number | null;
    displayName?: string | null;
    name?: string | null;
    /** @format int32 */
    sortOrder: number;
    value?: string | null;
}

export interface FiltersViewModel {
    attributeFilters?: MultipleOptionsFilterViewModel[] | null;
    categoryFilter?: CategoryFilterViewModel | null;
    priceRangeFilter?: PriceRangeFilterViewModel | null;
    singleOptionFilters?: SingleOptionFilterViewModel[] | null;
    wardrobeProfile?: WardrobeProfileViewModel | null;
}

export interface ItemCardAttributeViewModel {
    name?: string | null;
    values?: string[] | null;
}

export enum ItemCardSearchResultOrigin {
    Keyword = 'Keyword',
    Vector = 'Vector',
    KeywordAndVector = 'KeywordAndVector',
}

export interface ItemCardShippingOptionViewModel {
    /** @format int32 */
    cost: number;
    type?: string | null;
}

export interface ItemCardViewModel {
    attributes?: ItemCardAttributeViewModel[] | null;
    /** @format int32 */
    buyNowPrice: number;
    /** @format int32 */
    categoryId: number;
    /** @format int32 */
    discountRate: number;
    displayHighlighted: boolean;
    /** @format date-time */
    endDate: string;
    hasFreeShipping: boolean;
    /** @format int32 */
    imageHeight?: number | null;
    imageSecondaryUrlTemplate?: string | null;
    imageUrlTemplate?: string | null;
    /** @format int32 */
    imageWidth?: number | null;
    inWishList?: boolean | null;
    isActive: boolean;
    isAuthenticated: boolean;
    isAvailableForOffers?: boolean | null;
    /** @format int32 */
    itemId: number;
    itemType?: string | null;
    itemUrl?: string | null;
    onDisplay: boolean;
    /** @format int32 */
    price: number;
    /** @format int32 */
    priceBeforeDiscount: number;
    reservedPriceReached: boolean;
    searchResultOrigin?: ItemCardSearchResultOrigin | null;
    sellerAlias?: string | null;
    /** @format double */
    sellerDsrAverage?: number | null;
    /** @format int32 */
    sellerMemberId: number;
    shippingOptions?: ItemCardShippingOptionViewModel[] | null;
    shortDescription?: string | null;
    /** @format date-time */
    startDate: string;
    /** @format int32 */
    totalBids: number;
}

export interface ItemsByIdsApiResponse {
    items?: ItemCardViewModel[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface MoreItemsForCombinedShippingApiResponse {
    items?: ItemCardViewModel[] | null;
    /** @format int32 */
    itemsMatched: number;
    /** @format int32 */
    pageSize: number;
    responseStatus?: ResponseStatus | null;
}

export interface MoreItemsFromCategoryApiResponse {
    items?: ItemCardViewModel[] | null;
    /** @format int32 */
    itemsMatched: number;
    /** @format int32 */
    pageSize: number;
    responseStatus?: ResponseStatus | null;
}

export interface MoreItemsFromSellerApiResponse {
    items?: ItemCardViewModel[] | null;
    /** @format int32 */
    itemsMatched: number;
    /** @format int32 */
    pageSize: number;
    responseStatus?: ResponseStatus | null;
}

export interface MoreItemsFromSellerForCombinedShippingApiRequest {
    searchLanguageCodeIso2?: string | null;
    shippingCountryCodeIso2?: string | null;
    automaticTranslationPreferred: boolean;
    itemIds?: number[] | null;
    /** @format int32 */
    pageSize?: number | null;
    /** @format int32 */
    sellerMemberId: number;
    /** @format date-time */
    upsellItemEndDate?: string | null;
}

export interface MoreItemsFromShopApiResponse {
    items?: ItemCardViewModel[] | null;
    /** @format int32 */
    itemsMatched: number;
    /** @format int32 */
    pageSize: number;
    responseStatus?: ResponseStatus | null;
}

export interface MultipleOptionsFilterViewModel {
    displayName?: string | null;
    isIndexable: boolean;
    name?: string | null;
    options?: FilterOptionViewModel[] | null;
    parameter?: string | null;
    presentation?: string | null;
    preserveOptionsOrder: boolean;
    selectedValues?: string[] | null;
    translateOptions: boolean;
    type?: string | null;
}

export interface PaginationLinkViewModel {
    isSelected: boolean;
    /** @format int32 */
    pageIndex: number;
    paging?: string | null;
    state?: string | null;
}

export interface PaginationViewModel {
    firstPage?: PaginationLinkViewModel | null;
    lastPage?: PaginationLinkViewModel | null;
    /** @format int32 */
    pageCount: number;
    /** @format int32 */
    pageIndex: number;
    pageLinks?: PaginationLinkViewModel[] | null;
    /** @format int32 */
    pageSize: number;
}

export interface PriceRangeFilterOptionViewModel {
    parameter?: string | null;
    /** @format int32 */
    value?: number | null;
}

export interface PriceRangeFilterViewModel {
    fromPrice?: PriceRangeFilterOptionViewModel | null;
    name?: string | null;
    toPrice?: PriceRangeFilterOptionViewModel | null;
    type?: string | null;
}

export interface ProfileItemsApiRequest {
    languageCodeIso2: string;
    shippingCountryCodeIso2: string;
    allowedBuyerRegions?: string | null;
    applyWardrobeProfileBrands?: boolean | null;
    applyWardrobeProfileChildrenClothesSizes?: boolean | null;
    applyWardrobeProfileClothesSizes?: boolean | null;
    applyWardrobeProfileShoeSizes?: boolean | null;
    /** @deprecated */
    applyWardrobeProfileSizes?: boolean | null;
    attributes?: Record<string, string[] | null>;
    automaticTranslationPreferred: boolean;
    /** @format int32 */
    categoryId?: number | null;
    /** @format int32 */
    fromNumberOfBids?: number | null;
    /** @format int32 */
    fromPrice?: number | null;
    /** @format int32 */
    fromWishListCount?: number | null;
    itemCondition?: string | null;
    itemStatus?: string | null;
    itemType?: string | null;
    /** @format int32 */
    memberId: number;
    offerItemAvailability?: string | null;
    /** @format int32 */
    pageSize?: number | null;
    paging?: string | null;
    query?: string | null;
    queryScope?: string | null;
    searchInLongDescription?: boolean | null;
    shippingTypes?: string[] | null;
    sortBy?: string | null;
    /** @format int32 */
    toNumberOfBids?: number | null;
    /** @format int32 */
    toPrice?: number | null;
    /** @format int32 */
    toWishListCount?: number | null;
}

export interface ProfileItemsApiResponse {
    searchLanguageCodesIso2: string[];
    enableSavedSearch: boolean;
    filters: FiltersViewModel;
    isCsaSearchQuery: boolean;
    items: ItemCardViewModel[];
    onDisplayItems: ItemCardViewModel[];
    pagination: PaginationViewModel;
    redirect?: ProfileItemsRedirectViewModel | null;
    responseStatus?: ResponseStatus | null;
    /** @format int64 */
    totalItemCount: number;
}

export interface ProfileItemsRedirectViewModel {
    /** @format int32 */
    fromCategoryId: number;
    isPermanent: boolean;
    toAttributes: Record<string, string[]>;
    /** @format int32 */
    toCategoryId: number;
}

export interface IndependentSearchApiRequest {
    languageCodeIso2?: string | null;
    shippingCountryCodeIso2?: string | null;
    alias?: string | null;
    applyWardrobeProfileBrands?: boolean | null;
    applyWardrobeProfileChildrenClothesSizes?: boolean | null;
    applyWardrobeProfileClothesSizes?: boolean | null;
    applyWardrobeProfileShoeSizes?: boolean | null;
    /** @deprecated */
    applyWardrobeProfileSizes?: boolean | null;
    attributes?: Record<string, string[] | null>;
    automaticTranslationPreferred: boolean;
    /** @format int32 */
    categoryId?: number | null;
    county?: string | null;
    forceKeywordSearch: boolean;
    /** @format int32 */
    fromNumberOfBids?: number | null;
    /** @format int32 */
    fromPrice?: number | null;
    /** @format int32 */
    fromWishListCount?: number | null;
    /** @deprecated */
    includeFilters: boolean;
    itemCondition?: string | null;
    itemStatus?: string | null;
    itemType?: string | null;
    offerItemAvailability?: string | null;
    /** @format int32 */
    pageSize?: number | null;
    paging?: string | null;
    query?: string | null;
    queryScope?: string | null;
    searchInLongDescription?: boolean | null;
    searchTypeVariantHint?: string | null;
    /** @format int32 */
    sellerLocationDistance?: number | null;
    /** @format double */
    sellerLocationLat?: number | null;
    /** @format double */
    sellerLocationLong?: number | null;
    sellerType?: string | null;
    shippingTypes?: string[] | null;
    sortBy?: string | null;
    /** @format int32 */
    toNumberOfBids?: number | null;
    /** @format int32 */
    toPrice?: number | null;
    /** @format int32 */
    toWishListCount?: number | null;
    zipCode?: string | null;
}

export interface IndependentSearchApiResponse {
    filters?: FiltersViewModel | null;
    items?: ItemCardViewModel[] | null;
    pagination?: PaginationViewModel | null;
    responseStatus?: ResponseStatus | null;
    /** @format int64 */
    totalItemCount: number;
}

export interface WebGetSellerByAliasSearchApiResponse {
    responseStatus?: ResponseStatus | null;
    sellerOverviews?: SellerOverviewWithFavouriteSellerStatusDto[] | null;
    /** @format int32 */
    totalSellers: number;
}

export interface SearchCategoryRedirectViewModel {
    /** @format int32 */
    fromCategoryId: number;
    isPermanent: boolean;
    toAttributes?: Record<string, string[] | null>;
    /** @format int32 */
    toCategoryId: number;
}

export interface SearchPageApiRequest {
    languageCodeIso2?: string | null;
    shippingCountryCodeIso2?: string | null;
    alias?: string | null;
    allowedBuyerRegions?: string | null;
    applyWardrobeProfileBrands?: boolean | null;
    applyWardrobeProfileChildrenClothesSizes?: boolean | null;
    applyWardrobeProfileClothesSizes?: boolean | null;
    applyWardrobeProfileShoeSizes?: boolean | null;
    /** @deprecated */
    applyWardrobeProfileSizes?: boolean | null;
    attributes?: Record<string, string[] | null>;
    automaticTranslationPreferred: boolean;
    /** @format int32 */
    categoryId?: number | null;
    county?: string | null;
    forceKeywordSearch: boolean;
    /** @format int32 */
    fromNumberOfBids?: number | null;
    /** @format int32 */
    fromPrice?: number | null;
    /** @format int32 */
    fromWishListCount?: number | null;
    itemCondition?: string | null;
    itemStatus?: string | null;
    itemType?: string | null;
    offerItemAvailability?: string | null;
    /** @format int32 */
    pageSize?: number | null;
    paging?: string | null;
    query?: string | null;
    queryScope?: string | null;
    searchInLongDescription?: boolean | null;
    searchTypeVariantHint?: string | null;
    sellerType?: string | null;
    shippingTypes?: string[] | null;
    sortBy?: string | null;
    /** @format int32 */
    toNumberOfBids?: number | null;
    /** @format int32 */
    toPrice?: number | null;
    /** @format int32 */
    toWishListCount?: number | null;
    zipCode?: string | null;
}

export interface SearchPageApiResponse {
    searchLanguageCodesIso2?: string[] | null;
    enableSavedSearch: boolean;
    filters?: FiltersViewModel | null;
    /** @format int32 */
    fromCategoryId?: number | null;
    isCsaSearchQuery: boolean;
    isPermanent?: boolean | null;
    isRedirect: boolean;
    isSavedSearchEmailEnabled: boolean;
    isTooBroad: boolean;
    items?: ItemCardViewModel[] | null;
    pagination?: PaginationViewModel | null;
    redirect?: SearchCategoryRedirectViewModel | null;
    relatedItems?: ItemCardViewModel[] | null;
    responseStatus?: ResponseStatus | null;
    searchLanguages?: string[] | null;
    /** @format int32 */
    toCategoryId?: number | null;
    /** @format int64 */
    totalItemCount: number;
    /** @format int64 */
    totalItems: number;
}

export interface SingleOptionFilterViewModel {
    displayName?: string | null;
    isIndexable: boolean;
    name?: string | null;
    options?: FilterOptionViewModel[] | null;
    parameter?: string | null;
    presentation?: string | null;
    selectedValue?: string | null;
    translateOptions: boolean;
    type?: string | null;
}

export type BrandSuggestionsApiRequest = object;

export interface BrandSuggestionsApiResponse {
    brands?: SuggestedBrandViewModel[] | null;
    isTrendingBrands: boolean;
    responseStatus?: ResponseStatus | null;
}

export interface IdeaViewModel {
    /** @format int32 */
    categoryId?: number | null;
    imageUrlTemplate?: string | null;
    /** @format int32 */
    index: number;
    name?: string | null;
    type?: string | null;
    url?: string | null;
}

export interface IdeasApiResponse {
    ideas?: IdeaViewModel[] | null;
    responseStatus?: ResponseStatus | null;
}

export type InstagramFeedApiRequest = object;

export interface InstagramFeedApiResponse {
    posts?: InstagramPostViewModel[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface InstagramPostViewModel {
    imageUrl?: string | null;
    url?: string | null;
}

export interface LastChanceApiResponse {
    items?: ItemCardViewModel[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface NewsForYouApiResponse {
    items?: ItemCardViewModel[] | null;
    responseStatus?: ResponseStatus | null;
    /** @format int64 */
    totalItemCount: number;
}

export interface PersonalisedSearchViewModel {
    /** @format int32 */
    index: number;
    name?: string | null;
    url?: string | null;
}

export type PersonalisedSearchesApiRequest = object;

export interface PersonalisedSearchesApiResponse {
    responseStatus?: ResponseStatus | null;
    searches?: PersonalisedSearchViewModel[] | null;
}

export interface ResellSuggestionsApiResponse {
    items?: ItemCardViewModel[] | null;
    responseStatus?: ResponseStatus | null;
    /** @format int64 */
    totalItemCount: number;
}

export interface SellersOfInterestApiResponse {
    responseStatus?: ResponseStatus | null;
    sellerCards?: FavouriteSellerCardDto[] | null;
}

export interface StartPageApiRequest {
    languageCodeIso2?: string | null;
    shippingCountryCodeIso2?: string | null;
    preview: boolean;
    title?: string | null;
}

export interface StartPageApiResponse {
    configuration?: StartPageConfigurationViewModel | null;
    responseStatus?: ResponseStatus | null;
}

export interface StartPageConfigurationViewModel {
    content?: StartPageContentViewModel[] | null;
    header?: any;
    meta?: any;
}

export interface StartPageContentViewModel {
    data?: any;
    id?: string | null;
    type?: string | null;
}

export interface SuggestedBrandViewModel {
    /** @format int32 */
    categoryId?: number | null;
    /** @format int32 */
    index: number;
    name?: string | null;
    url?: string | null;
}

export interface TrendingBrandViewModel {
    /** @format int32 */
    categoryId?: number | null;
    /** @format int32 */
    index: number;
    logoImageUrl?: string | null;
    name?: string | null;
    slug?: string | null;
}

export type TrendingBrandsApiRequest = object;

export interface TrendingBrandsApiResponse {
    brands?: TrendingBrandViewModel[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface TrendingSearchViewModel {
    /** @format int32 */
    categoryId?: number | null;
    imageUrlTemplate?: string | null;
    /** @format int32 */
    index: number;
    query?: string | null;
}

export interface TrendingSearchesApiResponse {
    responseStatus?: ResponseStatus | null;
    searches?: TrendingSearchViewModel[] | null;
}

export interface TopListsApiResponse {
    mostActivePerCity?: Record<string, number>;
    mostActivePerCityAdjustedForPopulation?: Record<string, number>;
    mostBiddedItems?: ItemCardViewModel[] | null;
    mostExpensiveItems?: ItemCardViewModel[] | null;
    mostExpensiveSold?: ItemCardViewModel[] | null;
    mostWishListedItems?: ItemCardViewModel[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface TraderaShopProductApiResponse {
    product?: TraderaShopProductDto | null;
    responseStatus?: ResponseStatus | null;
}

export interface WardrobeProfileViewModel {
    areBrandFiltersApplied: boolean;
    areSizeFiltersApplied: boolean;
    areClothesSizeFiltersApplied: boolean;
    areChildrenClothesSizeFiltersApplied: boolean;
    areShoeSizeFiltersApplied: boolean;
    isEnabled: boolean;
    searchFilters?: SearchFilter[] | null;
}

export interface SavedSearchApiDto {
    /** @format int32 */
    id: number;
    name?: string | null;
    /** @format int32 */
    notificationType: number;
    notifyMemberWithPush: boolean;
    parameters?: SearchRequestParameters | null;
}

export interface SavedSearchEmailNotificationApiDto {
    /** @format int32 */
    id: number;
    sendMail: boolean;
    sendPush?: boolean | null;
}

export interface SavedSearchItemDto {
    imageUrlTemplate?: string | null;
    /** @format int32 */
    itemId: number;
    itemUrl?: string | null;
    title?: any;
}

export interface SavedSearchListItemApiDto {
    alternativeCategoryName?: string | null;
    categoryName?: string | null;
    /** @format int32 */
    id: number;
    name?: string | null;
    /** @format int32 */
    notificationType: number;
    notifyMemberWithPush: boolean;
    parameters?: SearchRequestParameters | null;
}

export interface TraderaShopProductRequest {
    languageCodeIso2?: string;
    urlSlug?: string;
}

export interface TrendingsellersAndItemsRequest {
    /** @format int32 */
    maxSellers?: number;
    /** @format int32 */
    maxItems?: number;
    /** @format int32 */
    maxItemsPerSeller?: number;
    /** @format int32 */
    skipItems?: number;
    shippingCountryCode?: string;
    userLanguage?: string;
    automaticTranslationPreferred?: boolean;
}

export interface ValuationSearchRequest {
    query?: string;
    /** @format int32 */
    categoryId?: number;
    searchResultLanguageCodeIso2?: string;
    itemCondition?: string;
    modelVersion?: string;
}

export interface WardrobeProfileRequest {
    request?: GetWardrobeProfileApiRequest;
}
